<div>
  <h1 anessaTranslation="RESULTS.SECTIONS.BASELINE_TECHNICAL"></h1>
  <!--INPUTS SET AS DEFAULT BUTTON-->
  <div>
    <app-result-set-config-btn *ngIf="resultConf"
                               [resultSetConfig]="resultConf"
                               (toggleChangeNotifier)="onResultSetDefaultChange()"
    >
    </app-result-set-config-btn>
  </div>
  <!--END SET AS DEFAULT BUTTON-->
  <!--START SELECTION BOXES-->
  <div class="row fl">
    <!-- Result Select -->
    <div class="fl-item max-width-33">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-technical-result_select"
          multiple
          disableOptionCentering
          placeholder="{{'RESULTS.GENERAL.SELECT_RESULTS' | anessaTranslation: trigger}}"
          [value]="selectedResults"
          (valueChange)="setTableData(); setResultSetConfDisabled()"
          panelClass="anessa-dropdown-panel">
          <ngx-mat-select-search
            placeholderLabel="{{'RESULTS.GENERAL.SEARCH' | anessaTranslation: trigger}}"
            noEntriesFoundLabel="{{'RESULTS.ERRORS.NO_RESULTS' | anessaTranslation: trigger}}"
            class="clear-search"
            [(ngModel)]="searchCriteria"
            (ngModelChange)="onSearchChange()">
            <i class="material-icons" ngxMatSelectSearchClear>
              delete
            </i>
          </ngx-mat-select-search>
          <div class="dropdown-select-all-container">
            <mat-checkbox
              class="mat-option mat-option-multi"
              color="primary"
              (change)="inputsCheckAll($event); setResultSetConfDisabled()"
              [checked]="allInputsSelected()"
              [indeterminate]="isCheckAllIndeterminate()"
              #inputsCheckbox>
              {{
                inputsCheckbox.checked ?
                ('RESULTS.GENERAL.DESELECT_ALL' | anessaTranslation: trigger) :
                ('RESULTS.GENERAL.SELECT_ALL' | anessaTranslation: trigger)
              }}
            </mat-checkbox>
          </div>
          <ng-container *ngFor="let group of filteredGroupData">
            <mat-option class="select-filter-option">
              <mat-checkbox
                [ngStyle]="{'padding-left.px': group.parent !== null ? 32 : 6.5 }"
                class="mat-option mat-option-multi"
                color="primary"
                (change)="optGroupClick(group, $event); setResultSetConfDisabled()"
                [checked]="allGroupInputsSelected(group)"
                [indeterminate]="isGroupIndeterminate(group)">
                {{ translatedResultSelectGroups[group.name] }}
              </mat-checkbox>
            </mat-option>
            <ng-container *ngFor="let result of filteredSearchData">
              <mat-option
                style="padding-left: 32px;"
                *ngIf="result.group === group.name && result.subGroup === null"
                [value]="result"
                (click)="optClick(result)">
                <p [innerHTML]="translatedResultSelectOptions[result.name]"></p>
              </mat-option>
              <mat-option
                style="padding-left: 48px;"
                *ngIf="result.subGroup === group.name"
                [value]="result"
                (click)="optClick(result)">
                {{ translatedResultSelectOptions[result.name] }}
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Period Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-technical-period_select"
          [(value)]="periodType"
          placeholder="{{'RESULTS.GENERAL.SET_PERIOD' | anessaTranslation: trigger}}"
          disableOptionCentering
          (valueChange)="setTableData(); setResultSetConfDisabled()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of periodCategories"
            [value]="opt.value">{{ opt.translationId}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Measurement System Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-technical-measurement_select"
          [(value)]="techUnitType"
          placeholder="{{'RESULTS.GENERAL.SET_UNIT_TYPE' | anessaTranslation: trigger }}"
          disableOptionCentering
          (valueChange)="setTableData(); setResultSetConfDisabled()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of techUnitTypes"
            [value]="opt.value">{{ opt.translationId }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!--END SELECTION BOXES-->
  <!-- START TABLE -->
  <div *ngIf="isShowResults()">
    <results-treetable
      [resultsData]="tableData"
      [groupAggregationMethod]="aggregationMethod"
      [aggregationWhiteList]="['RESULTS.DATA.TECHNICAL.RNGP']"
    ></results-treetable>
  </div>
<!--   END TABLE-->
</div>
